import Modal from "../Modal";
import "./UserEditDetailPopup.scss";
import Button from "components/inputs/Button";
import { Formik } from "formik";
import { getDataFromLocalStorage } from "utils/helpers";
import {
  getUserDetails,
  showSuccess,
  updateUserDetails,
} from "store/globalSlice";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { icons } from "utils/constants";
import { useState } from "react";
import Label from "components/inputs/Label";

const UserEditDetailPopup = ({ onHide, setIsModalOpen }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};
  const { account_id, first_name, last_name, email_id } =
    getDataFromLocalStorage();

  const dispatch = useDispatch();

  const initialValues = {
    first_name: first_name || "",
    last_name: last_name || "",
    email_id: email_id || "",
  };

  const validationSchema = Yup.object().shape({
    email_id: Yup.string().email("Email must be a valid email"),
  });

  const handleSave = async (values) => {
    setBtnLoading(true);
    const response = await dispatch(updateUserDetails(account_id, values));
    if (response?.status === 200) {
      dispatch(showSuccess("User details updated successfully."));
      await dispatch(getUserDetails());
      setIsModalOpen(false);
    }
    setBtnLoading(false);
  };

  return (
    <Modal
      width="600px"
      title={
        <span>
          Edit Details <span className={`${isDarkMode ? "color-c9c9" : "color-7e91"}`}>(optional)</span>
        </span>

      }
      onHide={onHide} isDarkMode={isDarkMode}>
      <div className="m-3">
        <Formik
          enableReinitialize
          onSubmit={handleSave}
          initialValues={initialValues}
          validationSchema={validationSchema}>
          {(props) => {
            const { values, errors, handleChange, handleSubmit } = props;
            const { first_name, last_name, email_id } = values;
            const {
              first_name: errFirstName,
              last_name: errLastName,
              email_id: errEmailId,
            } = errors;
            return (
              <form>
                <div className="row" id={`${isDarkMode ? "dark-userInput" : "userInput"}`}>
                  <div className="col-md-6 cmb-24">
                    <Label label="First Name" />
                    <input
                      type="text"
                      placeholder="Enter first name"
                      value={first_name}
                      id={"first_name"}
                      onChange={handleChange}
                      error={errFirstName}
                      maxLength="40"
                    />
                  </div>
                  <div className="col-md-6 cmb-24">
                    <Label label="Last Name" />
                    <input
                      type="text"
                      placeholder="Enter last name"
                      value={last_name}
                      id={"last_name"}
                      onChange={handleChange}
                      error={errLastName}
                      maxLength="30"
                    />
                  </div>
                  <div className="cmb-24">
                    <Label label="Email Address" />
                    <input
                      type="text"
                      placeholder="Enter email id"
                      value={email_id}
                      id={"email_id"}
                      onChange={handleChange}
                      error={errEmailId}
                      maxLength="60"
                    />
                  </div>
                  {/* <div className="col-md-6 cmb-24">
                    <Textinput
                      label="First name"
                      placeholder="Enter first name"
                      value={first_name}
                      id={"first_name"}
                      onChange={handleChange}
                      error={errFirstName}
                    />
                  </div>
                  <div className="col-md-6 cmb-24">
                    <Textinput
                      label="Last name"
                      placeholder="Enter last name"
                      value={last_name}
                      id={"last_name"}
                      onChange={handleChange}
                      error={errLastName}
                    />
                  </div>
                  <div className="cmb-24">
                    <Textinput
                      label="Email Address"
                      placeholder="Enter email id"
                      value={email_id}
                      id={"email_id"}
                      onChange={handleChange}
                      error={errEmailId}
                    />
                  </div> */}
                  <div className="d-flex justify-content-end">
                    <Button
                      btnStyle="PD"
                      leftIcon={icons.editLight}
                      btnText="Save Changes"
                      onClick={handleSubmit}
                      loading={btnLoading}
                    />
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </div>
    </Modal>
  );
};

export default UserEditDetailPopup;
